import React from 'react';
import { StyledModalCloseButtonWrapper } from '@/components/ui/ModalCloseButton/ModalCloseButton.styled.ts';
import CloseIcon from '@/components/icons/CloseIcon';

interface CloseProps {
  onClose: () => void;
}

const ModalCloseButton: React.FunctionComponent<CloseProps> = ({ onClose }) => {
  return (
    <StyledModalCloseButtonWrapper onClick={onClose}>
      <CloseIcon />
    </StyledModalCloseButtonWrapper>
  );
};

export default ModalCloseButton;
